import { createSlice } from "@reduxjs/toolkit";
const initialState={
  isLoading:false
}
export const Spinner = createSlice({
  name: "spinner",
  initialState: initialState,
  reducers: {
    showSpinner: (state,action) => {
        state.isLoading=action.payload.isLoading 
    },   
  },
});

// Action creators are generated for each case reducer function
export const {showSpinner} = Spinner.actions;

export default Spinner.reducer;


